import { useEffect } from 'react';
import { useDispatch } from 'redux-react-hook';
import { withI18n } from '@lingui/react'
import { setTitle } from 'store/modules/app/actions';
import Config from 'config';

/**
 * Sets the title into the html document and into the
 * reducer. Makes sure it doesn't contains xss attack
 * by only setting alphanumeric values
 * @param {Object} props
 */
function HeaderTitle({ i18n, i18nId, title }) {
  const dispatch = useDispatch();

  useEffect(() => {
    let translated = title;

    if (title) {
      dispatch(setTitle(''));
    } else {
      translated = i18n._(i18nId);

      if (i18nId === 'Not found') {
        dispatch(setTitle(''));
      } else {
        dispatch(setTitle(translated));
      }
    }

    if (translated) {
      document.title = `${translated} - ${Config.app.APP_TITLE}`;
    } else {
      document.title = Config.app.APP_TITLE;
    }
  }, [i18nId, title]);

  return null;
}

export default withI18n()(HeaderTitle);
